module.exports = __webpack_public_path__ + "static/img/rotate12.48bb643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate12.png
// module id = 4z98
// module chunks = 1